import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface OrderState {
  selectedOrderId: string | null;
  viewMode: 'table' | 'details' | 'buildings';
}

const initialState: OrderState = {
  selectedOrderId: null,
  viewMode: 'table',
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setSelectedOrderId: (state, action: PayloadAction<string | null>) => {
      state.selectedOrderId = action.payload;
    },
    setViewMode: (state, action: PayloadAction<'table' | 'details' | 'buildings'>) => {
      state.viewMode = action.payload;
    },
  },
});

// Export actions
export const { setSelectedOrderId, setViewMode } = orderSlice.actions;

// Export selectors
export const selectSelectedOrderId = (state: RootState) => state.order.selectedOrderId;
export const selectViewMode = (state: RootState) => state.order.viewMode;

// Export reducer
export default orderSlice.reducer;
